module.exports = "/public/images/d10202ddbd768236f4085a3707a73129.svg";